/** Format integer cents as a human-readable AUD string: 12345 → "$123.45" */
export function formatCents(cents: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

/** Parses a dollar string ("123.45") to integer cents (12345). */
export function parseDollarsToCents(dollars: string): number {
  return Math.round(parseFloat(dollars) * 100);
}
